import React, { useContext, useEffect, useRef, useState } from 'react';
import { SocketContext } from '../../../App';
import styles from './ReadyButton.module.css';

const ReadyButton = ({ isReady = false, dock = false, creatorStart = false, isCreator = false, canStart = false }) => {
    const socket = useContext(SocketContext);
    const [pending, setPending] = useState(false);
    const pendingTimerRef = useRef(null);

    useEffect(() => {
        setPending(false);
    }, [isReady, canStart, isCreator, creatorStart]);

    useEffect(() => () => {
        if (pendingTimerRef.current) clearTimeout(pendingTimerRef.current);
    }, []);

    const handleReady = () => {
        if (pending || typeof socket?.emit !== 'function') return;
        if (creatorStart) {
            if (!isCreator || !canStart) return;
            setPending(true);
            socket.emit('room:start');
        } else {
            if (isReady) return;
            setPending(true);
            socket.emit('player:ready');
        }

        // Server room:data normally clears pending almost immediately. This
        // fallback prevents a dropped packet from leaving the control disabled.
        if (pendingTimerRef.current) clearTimeout(pendingTimerRef.current);
        pendingTimerRef.current = setTimeout(() => setPending(false), 2500);
    };

    const actionDisabled = creatorStart
        ? (!isCreator || !canStart || pending || typeof socket?.emit !== 'function')
        : (isReady || pending || typeof socket?.emit !== 'function');
    const label = creatorStart
        ? pending
            ? 'STARTING…'
            : !isCreator
                ? (dock ? 'WAIT' : 'WAITING FOR CREATOR')
                : canStart
                    ? (dock ? 'START' : 'START GAME')
                    : (dock ? 'WAIT' : 'WAITING FOR FRIEND')
        : pending
            ? 'Updating…'
            : isReady
                ? 'Ready ✓'
                : dock
                    ? 'READY'
                    : 'Tap Ready';
    const ariaLabel = creatorStart
        ? !isCreator
            ? 'Waiting for room creator'
            : canStart
                ? 'Start game'
                : 'Waiting for players'
        : isReady
            ? 'Ready to play'
            : 'Mark ready to play';

    return (
        <button
            type="button"
            className={`${styles.readyButton} ${isReady ? styles.ready : ''} ${dock ? styles.dock : ''} ${creatorStart && canStart ? styles.start : ''}`}
            aria-pressed={creatorStart ? undefined : isReady}
            aria-label={ariaLabel}
            data-action={creatorStart ? 'creator-start' : 'ready'}
            data-creator={creatorStart ? String(isCreator) : undefined}
            disabled={actionDisabled}
            onClick={handleReady}
        >
            <span className={styles.statusDot} aria-hidden="true" />
            {label}
        </button>
    );
};

export default ReadyButton;
